<template>
  <div
    class="tooltip-container d-flex align-center"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @focus="handleMouseEnter"
    @blur="handleMouseLeave"
  >
    <span>{{ value }}</span>

    <button
      ref="tooltipBtn"
      class="tooltip-wrapper"
      aria-label="Show tooltip"
      type="button"
    >
      <v-icon small color="white" class="ml-1">mdi-information-outline</v-icon>

      <div
        v-if="show"
        class="custom-tooltip"
        :style="tooltipStyle"
      >
        <div v-if="title" class="tooltip-title">
          <v-icon small color="#378595" class="mr-1">mdi-clock-outline</v-icon>
          <strong>{{ title }}</strong>
        </div>
        <span>{{ description }}</span>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "HeaderTooltipInfo",
  props: {
    value: { type: [String, Number], required: true },
    title: { type: String, default: '' },
    description: { type: String, required: true }
  },
  data() {
    return {
      show: false,
      tooltipStyle: {}
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true);
  },
  methods: {
    handleMouseEnter() {
      const el = this.$refs.tooltipBtn;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      
      this.tooltipStyle = {
        position: 'fixed',
        top: `${rect.bottom + 8}px`,
        left: `${rect.left - 100}px`
      };
      
      this.show = true;
    },
    handleMouseLeave() {
      this.show = false;
    },
    handleScroll() {
      if (this.show) {
        this.show = false;
      }
    }
  }
};
</script>

<style scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
}

.tooltip-title {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

@keyframes borderPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(55, 133, 149, 0.4);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(55, 133, 149, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(55, 133, 149, 0);
  }
}

.custom-tooltip {
  z-index: 9999;

  background-color: white;
  color: #333;
  border: 2px solid #378595;
  border-bottom-width: 6px;
  padding: 8px 12px;
  border-radius: 10px;

  width: max-content;
  max-width: 300px;
  min-width: 120px;

  font-size: 14px;
  text-align: left;
  white-space: normal;
  word-break: break-word;

  animation: borderPulse 2s ease-out infinite;
}
</style>
